import React, {useRef} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

import {BucketConfigForm, BucketConfigFormRefHandle} from './BucketConfigForm';
import {BucketImageDocType} from 'models/config/BucketImageDocType';

export type BucketConfigFormModalProps = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    disabledKeyField?: boolean;
    defaultValues?: BucketImageDocType;
    onSubmit?: (bucketConfig: BucketImageDocType) => void;
};

export const BucketConfigFormModal = (
    props: BucketConfigFormModalProps
) => {
    const {
        disabledKeyField,
        title,
        isOpen,
        onClose,
        defaultValues,
        onSubmit
    } = props;

    const formRef = useRef<BucketConfigFormRefHandle>(null);

    const handleSaveClick = () => {
        const bucketConfig = formRef.current?.submit();
        if (!bucketConfig) {
            return;
        }

        onSubmit?.(bucketConfig);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                <BucketConfigForm
                    ref={formRef}
                    disabledKeyField={disabledKeyField}
                    defaultValues={defaultValues}
                />
            </ModalBody>
            <ModalFooter className="tw-flex tw-justify-end">
                <Button
                    color="primary"
                    onClick={handleSaveClick}
                >
                    Save
                </Button>
                <Button
                    color="secondary"
                    onClick={onClose}
                    className="tw-border-none tw-bg-neutral-600"
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};